
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(8(05[57]|484|524|898)|3(060|16|370)|6(061|152|550|607)|2480|4111|7373)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
